<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='车架号：'>
          <el-input v-model='searchForm.frameNumber' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"
          />
        </el-form-item>
        <el-form-item label='质损类型:'>
          <el-select v-model='searchForm.typeName' size='mini' placeholder='请选择质损类型'>
            <el-option label='全部' value='' />
            <el-option v-for='item in selectedOptions.type' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='质损部位:'>
          <el-select v-model='searchForm.partName' size='mini' placeholder='请选择质损部位'>
            <el-option label='全部' value='' />
            <el-option v-for='item in selectedOptions.position' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot='label'>
            <el-select v-model='dateStr' size='mini' placeholder='请选择日期'>
              <el-option v-for='item in dateStrOptions' :label='item.value' :value='item.field'
                         :key='item.field' />
            </el-select>
          </div>
          <el-date-picker
            style='margin-left: 40px;'
            size='mini'
            v-model='date'
            value-format='yyyy-MM-dd'
            type='daterange'
            unlink-panels
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='责任单位：'>
          <el-input v-model='searchForm.responsibleUnit' size='mini' placeholder='请输入责任单位' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='btnClick("batchFinish")'>完成</el-button>
          <el-button size='small' type='danger' @click='btnClick("batchDelete")'>删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @selection-change='selectionChange'
        :row-style="rowStyle">
        <el-table-column type='selection' align='center' min-width='50' />
        <el-table-column label='发运日期' prop='massLossTime' align='center' width='180'
                         :formatter='dateFormat' />
        <el-table-column label='邮件报备日期' prop='reportingDate' align='center' width='180'
                         :formatter='dateFormat' />
        <el-table-column label='批次号' prop='batchNumber' align='center' width='180' />
        <el-table-column label='运单号' prop='waybillNo' align='center' width='180' />
        <el-table-column label='车架号' prop='frameNumber' align='center' width='180' />
        <el-table-column label='运输方式' prop='taskMode' align='center' :formatter='taskModeFormat'
                         width='120' />
        <el-table-column label='品牌' prop='brand' align='center' />
        <el-table-column label='车型' prop='model' align='center' width='120' />
        <el-table-column label='责任单位' prop='responsibleUnit' align='center' width='120' />
        <el-table-column label='质损类型' prop='typeName' align='center' width='120' />
        <el-table-column label='质损部位（位置）' prop='partName' align='center' width='140' />
        <el-table-column label='定损金额' prop='pricingAmount' align='center' />
        <el-table-column label='降价金额' prop='priceReductionAmount' align='center' />
        <el-table-column label='买断金额' prop='buyoutAmount' align='center' />
        <el-table-column label='发票金额' prop='invoicePrice' align='center' />
        <el-table-column label='开票日期' prop='invoiceTime' align='center' :formatter='dateFormat' />
        <el-table-column label='开票单位' prop='invoiceCompany' align='center' />
        <el-table-column label='创建时间' prop='createTime' align='center' />
        <el-table-column label='航向' prop='azimuth' align='center' />
        <el-table-column label='状态' prop='status' align='center' :formatter='statusFormat' />
        <el-table-column label='操作' width='280' align='center' fixed='right'>
          <template slot-scope='scope'>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='btnClick("info", scope.row)'>
              详情
            </el-button>
            <el-button size='mini' v-if='scope.row.status !== 2' class='yellow-bg' type='primary'
                       @click='btnClick("complete", scope.row)'>
              完善
            </el-button>
            <el-button size='mini' v-if='scope.row.status !== 2' type='primary'
                       @click='btnClick("finish", scope.row)'>
              完成
            </el-button>
            <el-button size='mini' v-if='scope.row.status !== 2' type='danger'
                       @click='btnClick("delete", scope.row)'>删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 完善 -->
    <quality-loss-list-form ref='qualityLossListFormRef' @searchBtn='searchBtn' />
    <!-- 详情 -->
    <quality-loss-list-info ref='qualityLossListInfoRef' />
  </div>
</template>

<script>
  import QualityLossListForm from './components/form';
  import QualityLossListInfo from './components/info';
  import BatchImport from '@/components/batchImport';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import {
    completionQualityLoss,
    deleteQualityLoss,
    perfectDropDownDataGather,
    qualityDamageList, tableListPage,
  } from '@/service/vehiclelog';
  import message from "element-ui/packages/message";

  export default {
    name: 'qualityLossList',
    components: {
      BatchImport,
      QualityLossListForm,
      QualityLossListInfo,
    },
    data() {
      return {
        importLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        searchForm: {
          waybillNo: '',
          batchNumber: '',
          frameNumber: '',
          typeName: '',
          partName: '',
          responsibleUnit: '',
          page: 1,
          rows: 10,
        },
        dateStr: '',
        date: ['', ''],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [
          {
            id: 1,
            total: 10,
          },
          {
            id: 2,
            total: 20,
          },
        ],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectedData: [],
        dateStrOptions: [
          {
            value: '发运日期',
            field: '0',
          },
          {
            value: '邮件报备日期',
            field: '1',
          },
          {
            value: '开票日期',
            field: '2',
          },
          {
            value: '收到发票日期',
            field: '3',
          },
          {
            value: '扣款时间',
            field: '4',
          },
          {
            value: '付款时间',
            field: '5',
          },
          {
            value: '索赔材料邮寄重庆时间',
            field: '6',
          },
          {
            value: '向保险公司索赔时间',
            field: '7',
          },
          {
            value: '保险公司回款时间',
            field: '8',
          },
          {
            value: '向垫付单位回款时间',
            field: '9',
          },
          {
            value: '卸船日期',
            field: '10',
          },
          {
            value: '创建时间',
            field: '11',
          },
        ],
        uploadUrl: '/vehicleMassLossInfo/batchImport',
        selectedOptions: {},
      };
    },
    created() {
      this.getSelectedData();
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      dateFormat(r, c, cellValue) {
        return cellValue ? cellValue.substring(0, 10) : '';
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.searchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await perfectDropDownDataGather();
        if (status !== 0) return this.$message.warning(message);
        console.log(this.selectedOptions);
        this.selectedOptions = data;
      },
      btnClick(str, row) {
        switch (str) {
          case 'complete':
            this.$refs.qualityLossListFormRef.dialogOpen('完善', row);
            break;
          case 'info':
            this.$refs.qualityLossListInfoRef.dialogOpen(row);
            break;
          case 'delete':
            this.qualityLossDelete(row.id);
            break;
          case 'batchDelete':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后删除！');
            const batchDeleteIds = this.selectedData.map(item => item.id)
              .join(',');
            this.qualityLossDelete(batchDeleteIds);
            break;
          case 'finish':
            this.finish(row.id);
            break;
          case 'batchFinish':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后提交！');
            const batchFinishIds = this.selectedData.map(item => item.id)
              .join(',');
            this.finish(batchFinishIds);
            break;
        }
      },
      /**
       * 完成
       * @param ids
       */
      finish(ids) {
        this.$confirm('确认完成当前选中质损信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await completionQualityLoss({ ids });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.clearSelectedData();
          });
      },
      /**
       * 删除
       * @param ids
       */
      qualityLossDelete(ids) {
        this.$confirm('确认删除当前选中数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await deleteQualityLoss({ ids });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.clearSelectedData();
          });
      },
      // 质损类型格式化
      taskModeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '公路';
          case 1:
            return '水路';
        }
      },
      // 质损类型格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '待审核';
          case 1:
            return '待完善';
          case 2:
            return '已完成';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
        // this.tableListData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.dateStr = '';
        this.date = ['', ''];
      },
      //分页查询
      async tableListData(){
        let obj = {
              frameNumber: '',
              typeName: '',
              partName: '',
              responsibleUnit: '',
              page: 1,
              rows: 10,
              queryState: '',
              startDate: '',
              endDate: ''
            }
        const res = await tableListPage(obj)
        if (res.status !== 0) return this.$message.error(message);
        this.tableData = data.records;
        this.total = data.total;

      },
      // 获取表格数据
      async getTableData() {
        if (this.date[0] && this.dateStr === '') return this.$message.warning('如选择日期，请选择对应什么日期');
        if (this.dateStr !== '' && this.date[0] === '') return this.$message.warning('选择对应日期后，必须选择日期区间！');
        const params = {
          ...this.searchForm,
          queryState: this.dateStr,
          startDate: this.date[0],
          endDate: this.date[1],
        };
        // if (this.dateStr) params[this.dateStr] = this.date.join(',');
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await qualityDamageList(params);
        this.tableLoading = false;
        if (status !== 0) return this.$message.error(message);
        this.tableData = data.records;
        this.total = data.total;
        await this.tableListData();
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      clearSelectedData() {
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        if (this.date[0] && this.dateStr === '') return this.$message.warning('如选择日期，请选择对应什么日期');
        if (this.dateStr !== '' && this.date[0] === '') return this.$message.warning('选择对应日期后，必须选择日期区间！');
        // if (this.dateStr) url += `&${this.dateStr}=${this.date.join(',')}`;
        // window.location.href = `${baseUrl}/platform/vehicleMassLossInfo/export?access_token=${token}&frameNumber=${this.searchForm.frameNumber}&typeName=${this.searchForm.typeName}&partName=${this.searchForm.partName}&responsibleUnit=${this.searchForm.responsibleUnit}&queryState=${this.dateStr}&startDate=${this.date[0]}&endDate=${this.date[1]}`;
        window.exportExcelGet('/platform/vehicleMassLossInfo/export', `frameNumber=${this.searchForm.frameNumber}&typeName=${this.searchForm.typeName}&partName=${this.searchForm.partName}&responsibleUnit=${this.searchForm.responsibleUnit}&queryState=${this.dateStr}&startDate=${this.date[0]}&endDate=${this.date[1]}`);
      },
      download() {
        window.location.href = '/file/质损信息导入模板.xlsx';
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
